<template>
    <el-dialog
        :visible="visible"
        title="Add Users to Inboxes"
        width="95vw"
        custom-class="ring-group-bulk-manage-modal"
        top="10vh"
        append-to-body
        :before-close="onBeforeCloseModal"
        @close="onClose"
    >
        <el-alert :closable="false" type="info" class="mb-4">
            <span class="text-dark">Add Users as Watchers to Inboxes</span>
            <ul class="text-dark">
                <li>Select one or more Users to add as Watchers</li>
                <li>Select one or more Inboxes to assign them to</li>
            </ul>
        </el-alert>
        <el-form :rules="rules" :ref="form_name" @submit.native.prevent="onSubmit" :model="form_data">
            <el-form-item label="Select Users:" prop="user_ids">
                <user-selector
                    v-model="form_data.user_ids"
                    multiple
                    only-active
                    show-bulk-actions
                    :hide_extensions="true"
                    placeholder="Select or Search Users"
                    @change="handleUserChange"
                />
            </el-form-item>
            <el-form-item label="Select Inboxes:" prop="ring_group_ids">
                <ring-group-selector
                    v-model="form_data.ring_group_ids"
                    multiple
                    show-icons
                    show-bulk-actions
                    include-personal-inboxes
                    custom-placeholder="Select or Search Inboxes"
                    @change="handleRingGroupChange"
                />
            </el-form-item>
        </el-form>
        <div class="row mt-5">
            <div class="col-12">
                <el-button 
                    type="success"
                    class="pull-right"
                    data-testid="ring-group-bulk-manage-modal-save-input"
                    :disabled="loading"
                    @click="onSubmit"
                >
                    <span class="fa fa-save"></span>
                    <span>Save</span>
                </el-button>
                <el-button 
                    type="info"
                    class="pull-right mr-2"
                    data-testid="ring-group-bulk-manage-modal-cancel-input"
                    :disabled="loading"
                    @click="onCancel"
                >
                    <span class="fa fa-close"></span>
                    <span>Cancel</span>
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import ringGroupSelector from '../ring-group-selector.vue'
import userSelector from '../user-selector.vue'
import { form_validation_mixin } from '../../mixins'
import { RING_GROUP_BULK_ADD_USERS_TYPE_WATCHER } from '../../constants/ring-group-bulk-add-users-types';

export default {
    name: 'RingGroupBulkManageModal',

    mixins: [
        form_validation_mixin
    ],

    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    components: { ringGroupSelector, userSelector },

    data() {
        return {
            loading: false,
            form_name: 'ring_group_bulk_manage_form',
            form_data: {
                ring_group_ids: [],
                user_ids: [],
                type: RING_GROUP_BULK_ADD_USERS_TYPE_WATCHER
            },
            rules: {
                ring_group_ids: [
                    {
                        validator: (rule, value, callback) => {
                            if (!this.form_data.ring_group_ids || this.form_data.ring_group_ids.length === 0) {
                                callback(new Error('Please select at least one inbox'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ],
                user_ids: [
                    {
                        validator: (rule, value, callback) => {
                            if (!this.form_data.user_ids || this.form_data.user_ids.length === 0) {
                                callback(new Error('Please select at least one user'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ]
            }
        }
    },

    methods: {
        onClose() {
            this.$emit('close')
            this.resetFormData()
        },

        onCancel() {
            this.checkUnsavedChanges(this.onClose)
        },

        onBeforeCloseModal(done) {
            this.checkUnsavedChanges(done)
        },

        checkUnsavedChanges(closeCallback) {
            if (this.form_data.ring_group_ids?.length > 0 || this.form_data.user_ids?.length > 0) {
                this.$confirm('Are you sure you want to leave? Your changes will not be saved.', 'Warning', {
                    confirmButtonText: 'Yes, Leave',
                    cancelButtonText: 'No, Stay',
                    customClass: 'width-500 fixed',
                    type: 'warning'
                }).then(() => {
                    this.resetFormData()
                    closeCallback()
                }).catch(() => {
                    // User clicked "No, Stay" - do nothing, modal stays open
                })
            } else {
                this.resetFormData()
                closeCallback()
            }
        },

        resetFormData() {
            this.form_data.ring_group_ids = []
            this.form_data.user_ids = []
            this.form_data.type = RING_GROUP_BULK_ADD_USERS_TYPE_WATCHER
            this.resetForm(this.form_name)
        },

        handleRingGroupChange(value) {
            this.form_data.ring_group_ids = value
            this.preValidateForm(this.form_name)
        },

        handleUserChange(value) {
            this.form_data.user_ids = value
            this.preValidateForm(this.form_name)
        },

        onSubmit() {
            if (!this.validateForm(this.form_name)) {
                return
            }

            this.loading = true

            axios.put('/api/v1/ring-groups/bulk-add-users', this.form_data)
                .then(({ data }) => {
                    this.$notify.success({
                        title: 'Add Users to Inboxes',
                        message: data.message,
                    })
                    this.onClose()
                })
                .catch(({ response }) => {
                    this.$root.handleErrors(response)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style>
.ring-group-bulk-manage-modal {
    max-width: 700px;
}
</style>
